<div class="header-menu" [style.display]="headerOpened ? 'block' : 'none'">
  <div class="container container_type_header-menu">
    <div class="header-menu__leftbar">
      <div class="header-menu__leftbar-title">{{ 'header.catalog' | translate }}</div>
      <div class="header-menu__leftbar-list">
        <div class="header-menu__leftbar-item" *ngFor="let tag of tags">
          <a routerLink="/genres" [queryParams]="{id: tag.id}" class="header-menu__leftbar-link with-icon">{{ tag.title }}<i [ngClass]="getIconClass(tag)"></i></a>
        </div>
      </div>
    </div>
    <div class="header-menu__content">
      <div class="subtitle" *ngIf="showHits">
        <div class="header-menu__content-title">{{ 'header-search.season-hits' | translate }}</div>
      </div>
      <div class="songs-list" *ngIf="showHits">
        <div class="songs-list__item" app-melody-item *ngFor="let melody of hitsMelodies" [melody]="melody"></div>
      </div>

      <div class="header-menu__notfound" *ngIf="!showHits && searchArtistsResult.length == 0 && searchMelodiesResult.length == 0 && !melodiesLoadInProgress && !artistsLoadInProgress">
        <div class="header-menu__notfound-img"></div>
        <div class="header-menu__notfound-title h2">{{ 'header-search.no-results' | translate:{searchText: searchText} }}</div>
        <div class="header-menu__notfound-text">{{ 'header-search.no-results-hint' | translate }}</div>
      </div>
      <div class="subtitle" *ngIf="searchMelodiesResult.length > 0">
        <div class="header-menu__content-title">{{ 'header-search.tracks' | translate }}</div>
        <div class="subtitle__link" *ngIf="!melodiesLoadInProgress && searchMelodiesCount > searchMelodiesResult.length">
          <span class="subtitle__link-link" (click)="searchAllMelodies()">
            <span class="subtitle__link-link-desktop">{{ 'header-search.see-all' | translate }}</span>
            <span class="subtitle__link-link-mobile">{{ 'header-search.all' | translate }}</span></span>
        </div>
      </div>
      <div class="songs-list" *ngIf="searchMelodiesResult.length > 0">
        <div class="songs-list__item" app-melody-item *ngFor="let melody of searchMelodiesResult" [melody]="melody"></div>
      </div>
      <div class="subtitle" *ngIf="searchArtistsResult.length > 0">
        <div class="header-menu__content-title">{{ 'header-search.artists' | translate }}</div>
        <div class="subtitle__link" *ngIf="!artistsLoadInProgress && searchArtistsCount > searchArtistsResult.length">
          <span class="subtitle__link-link" (click)="searchAllArtists()">
            <span class="subtitle__link-link-desktop">{{ 'header-search.see-all' | translate }}</span>
            <span class="subtitle__link-link-mobile">{{ 'header-search.all' | translate }}</span>
          </span>
        </div>
      </div>
      <div class="songs-list" *ngIf="searchArtistsResult.length > 0">
        <div class="songs-list__item" app-header-artist-item *ngFor="let artist of searchArtistsResult" [artist]="artist"></div>
      </div>
    </div>
  </div>
</div>
